import { DocumentObject } from 'jsonapi-fractal';
import { parseJsonApi } from './jsonApi';

/**
 * Deserializes a JSON:API response, converting attribute names to camelCase.
 *
 * Prefer `getJsonApi` / `getAllJsonApiPages` / `parseJsonApi` from
 * `./jsonApi` for new code; this is kept for existing callers.
 */
export function deserializeData<T>(data: DocumentObject): T {
  return parseJsonApi<T>(data, { keyCase: 'camel' }).data;
}
